<ion-item class="ion-text-center">
  <div class="display__flex justify__space__evenly width__100">
    <h1 (click)="openTrattamento()">{{this.customTextOne}}</h1><br>
    <h1 (click)="openFinalita()">{{this.customTextTwo}}</h1>
  </div>
</ion-item>